import React, { type ReactElement } from 'react'

import styles from './WelcomeHeader.module.scss'

interface WelcomeHeaderProps {
  title: string
  subtitle: string
}
const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({ title, subtitle }): ReactElement => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
    </div>
  )
}

export default WelcomeHeader
